module.exports = __webpack_public_path__ + "img/Recurso 37@300x.5a5f3e45.png";